import React from 'react';
import { Tree } from 'antd';
import DynamicTreeData from './DynamicTreeData';

export default function NavigationBar() {    
       
    const treeData = DynamicTreeData();
    return (<Tree showIcon defaultExpandAll={true} treeData={treeData} />);

}